import BaseBridge from 'config/bridge/BaseBridge'
import BaseService from 'config/bridge/BaseService'
import { BridgeMockUserInfo } from 'config/bridge/BridgeMock'
import { IEligibility } from 'store/eligibility/types'

export default class EligibilityService {
  static async getEligibility() {
    let headers = {}

    if (BaseBridge.isBrowser()) {
      headers = {
        'x-inter-user-bank-account': BridgeMockUserInfo.account,
      }
    }

    const response = await BaseService.doExecute<IEligibility>({
      method: 'GET',
      endpoint: `${process.env.REACT_APP_API_CAPITALIZATION}/widgets/status/SORTEZINHA`,
      headers,
    })

    return response.data
  }
}
